export default __webpack_public_path__ + "img/bd6b95c84e72d183338e6bb8f716d387.png";